import { useState, memo, Fragment, useEffect, useRef } from "react";
import { Offcanvas, Row, Col } from "react-bootstrap";
import { useGetProjectTypes } from "../../../../queries/query-hooks/workspace/workspace-hook";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../../../store/auth/selectors";
import { updateFilters } from "../../../../store/common/actions";
import { selectedFilters } from "../../../../store/common/selectors";

const ProjectFilter = memo(
  ({
    show,
    setShow,
    handleFilterSubmit = () => {},
    projectMasterType = "",
    setFilterState = () => {},
  }) => {
    const user = useSelector(authSelectors.user);
    const filters = useSelector(selectedFilters);
    const dispatch = useDispatch();

    const isSuperAdmin = user?.user_has_role?.role_id === 1;
    const isUserHasViewInactiveProjectPermission =
      user?.user_has_permissions?.some(
        (item) => item?.name === "view_inactive_project"
      );

    const { data: getProjectTypes, isLoading: isGetProjectTypes } =
      useGetProjectTypes();
    const [projectTypes, setProjectTypes] = useState([]);
    const [projectName, setProjectName] = useState("");
    const [projectTag, setProjectTag] = useState("");
    const [projectType, setProjectType] = useState("");
    const [projectStatus, setProjectStatus] = useState("");

    useEffect(() => {
      if (Object.keys(filters).length > 0) {
        setProjectName(filters?.project_name?.value || "");
        setProjectTag(filters?.tag?.value || "");
        setProjectType(filters?.project_type_id?.value || "");
        setProjectStatus(filters?.project_status?.value || "");
      }
      if (getProjectTypes) {
        if (projectMasterType === "doctube") {
          const doctubeChannels = getProjectTypes?.project_type_masters.filter(
            (item) => item.id === 1
          );
          setProjectTypes(doctubeChannels);
        } else {
          const clirnetProjects = getProjectTypes?.project_type_masters.filter(
            (item) => item.id !== 1
          );
          setProjectTypes(clirnetProjects);
        }
      }
    }, [getProjectTypes, projectMasterType, filters]);

    const handleApply = (e) => {
      e.preventDefault();
      handleFilterSubmit({
        project_name: projectName,
        tag: projectTag,
        project_status: projectStatus,
        project_type_id: projectType,
      });
      setShow(false);
    };

    const handleClose = () => {
      setShow(false);
      setProjectName("");
      setProjectTag("");
      setProjectType("");
      setProjectStatus("");
    };

    const resetFilter = () => {
      setProjectName("");
      setProjectTag("");
      setProjectType("");
      setProjectStatus("");
      setFilterState({});
      dispatch(updateFilters({}));
      setShow(false);
    };

    return (
      <>
        <form>
          <Offcanvas
            show={show}
            onHide={handleClose}
            placement={`end`}
            backdrop={true}
            scroll={true}
            className="live-customizer"
          >
            <Offcanvas.Header className="shadow" closeButton={handleClose}>
              <div className="d-flex align-items-center">
                <h5 className="offcanvas-title" id="live-customizer-label">
                  Filter Options
                </h5>
              </div>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Row>
                <Col md={12}>
                  <div className="mb-3">
                    <label
                      htmlFor="projectName"
                      className="form-label poppins-medium text-secondary"
                    >
                      Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="projectName"
                      placeholder="Enter Project Name"
                      value={projectName}
                      onChange={(e) => setProjectName(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="projectTag"
                      className="form-label poppins-medium text-secondary"
                    >
                      Tag
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="projectTag"
                      placeholder="Enter Project Tag"
                      value={projectTag}
                      onChange={(e) => setProjectTag(e.target.value)}
                    />
                  </div>

                  <div className="mb-3">
                    <label
                      htmlFor="projectType"
                      className="form-label poppins-medium text-secondary"
                    >
                      Type
                    </label>
                    <select
                      className="form-select"
                      id="projectType"
                      value={projectType}
                      onChange={(e) => setProjectType(e.target.value)}
                    >
                      <option value="">Select Project Type</option>
                      {projectTypes.map((item, index) => {
                        return (
                          <option
                            value={item.id}
                            key={`project-type-${item.id}`}
                          >
                            {item.project_type_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  {isSuperAdmin || isUserHasViewInactiveProjectPermission ? (
                    <div className="mb-3">
                      <label
                        htmlFor="projectStatus"
                        className="form-label poppins-medium text-secondary"
                      >
                        Status
                      </label>
                      <select
                        className="form-select"
                        id="projectStatus"
                        value={projectStatus}
                        onChange={(e) => setProjectStatus(e.target.value)}
                      >
                        <option value="">Select Project Status</option>
                        <option value="1">Enabled</option>
                        <option value="2">Disabled</option>
                      </select>
                    </div>
                  ) : null}
                </Col>
              </Row>
            </Offcanvas.Body>
            <div className="d-flex justify-content-end gap-3 px-3 py-3 shadow">
              <button
                type="button"
                className="btn flex-grow-1 btn-soft-secondary"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn flex-grow-1 btn-soft-primary"
                onClick={resetFilter}
              >
                Reset
              </button>
              <button
                onClick={handleApply}
                className="btn flex-grow-1 btn-primary"
              >
                Apply
              </button>
            </div>{" "}
          </Offcanvas>
        </form>
      </>
    );
  }
);

export default ProjectFilter;
